// extracted by mini-css-extract-plugin
export var body = "_2d-8";
export var button = "_2d-0";
export var closeButton = "_2d-5";
export var content = "_2d-3";
export var empty = "_2d-f";
export var grid = "_2d-c";
export var header = "_2d-4";
export var icon = "_2d-1";
export var option = "_2d-d";
export var optionSelected = "_2d-e";
export var overlay = "_2d-2";
export var searchIcon = "_2d-a";
export var searchInput = "_2d-b";
export var searchWrapper = "_2d-9";
export var title = "_2d-6";
export var visuallyHidden = "_2d-7";